import React from "react";
import styles from "./CustomRadioButton.module.css";
import {
	fw400,
	fw300,
	primaryTextColor,
	secondaryTextColor,
	titleM,
	titleS,
} from "../../../Global.module.css";

export default function CustomRadioButton({
	activeState,
	clickMethod,
	compareState,
	title,
	subTitle,
	disabled,
}) {
	const activeRadioButtonStyles = [
		`${styles.radioBtn} ${styles.active}`,
		`${primaryTextColor} ${titleM} ${fw400}`,
		`${primaryTextColor} ${titleS} ${fw300}`,
	];
	const inactiveRadioButtonStyles = [
		`${styles.radioBtn} ${styles.inactive}`,
		`${secondaryTextColor} ${titleM} ${fw400}`,
		`${secondaryTextColor} ${titleS} ${fw300}`,
	];

	return (
		<button
			className={styles.optionBtn}
			disabled={disabled}
			onClick={clickMethod}
		>
			<span
				className={
					activeState === compareState
						? activeRadioButtonStyles[0]
						: inactiveRadioButtonStyles[0]
				}
			></span>
			<p
				className={
					activeState === compareState
						? activeRadioButtonStyles[1]
						: inactiveRadioButtonStyles[1]
				}
			>
				{title}
				<br />
				<span
					className={
						activeState === compareState
							? activeRadioButtonStyles[2]
							: inactiveRadioButtonStyles[2]
					}
				>
					{subTitle}
				</span>
			</p>
		</button>
	);
}
